@if (isLoggedIn$ | ngrxPush) {
  <ng-container
    *ngrxLet="
      baseSoftware$ as baseSoftware;
      error as e;
      complete as isCompleted;
      suspenseTpl: loading
    "
  >
    @if (e) {
      <dp-internal-server-error
        (onReloadClick)="reloadPage()"
      ></dp-internal-server-error>
    } @else if (isCompleted && baseSoftware) {
      <dp-download-details-page-content
        [download]="baseSoftware"
        backLinkLabel="Basis-Software"
        backLinkUrl="../../lists/packages"
      ></dp-download-details-page-content>
    } @else {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    }
  </ng-container>
} @else {
  <div class="p-6 mx-auto max-w-screen-md">
    <mat-card>
      <dp-logged-out-state></dp-logged-out-state>
    </mat-card>
  </div>
}

<ng-template #loading>
  <div class="pt-4 flex content-center justify-center">
    <download-portal-loader></download-portal-loader>
  </div>
</ng-template>
